// extracted by mini-css-extract-plugin
export default {"container":"ClubRules_container__AWIpX","frame":"ClubRules_frame__GJUBy","save":"ClubRules_save__FZQe4","tooltip":"ClubRules_tooltip__GJ8qE"};